import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(main)/servers/my-server.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/(main)/servers/page.footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/(main)/servers/server-list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/require-login.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/scroll-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/tran.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServerTabs","ServerTabsList","ServerTabsTrigger","ServerTabsContent"] */ "/vercel/path0/components/ui/server-tabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/layout/client-protected-element.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.4_babel-plugin-react-compiler@19.0.0-beta-e993439-20250328_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.4_babel-plugin-react-compiler@19.0.0-beta-e993439-20250328_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
